import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { class: "p-field-label" }
const _hoisted_3 = { class: "apartment-selector__page" }
const _hoisted_4 = { class: "dialog-custom__title mt-3" }
const _hoisted_5 = { class: "fs-13 label-error max-badges" }
const _hoisted_6 = { class: "fs-13 label-error max-badges" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListItemRadio = _resolveComponent("ListItemRadio")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_ScrollableTabView = _resolveComponent("ScrollableTabView")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("AppResourceEP.AddBadgesApartmentsSubtitle")), 1)
    ]),
    _createVNode("span", _hoisted_3, [
      (
                _ctx.currentEntrancePlant.addressingType ===
                _ctx.AddressingType.BuildingRiserFloorApartment
            )
        ? (_openBlock(), _createBlock(_component_ScrollableTabView, {
            key: 0,
            scrollable: "",
            class: "p-tabview--custom add-badge-tab mt-3 white-back"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildingStructure, (riserTab, riserIndex) => {
                return (_openBlock(), _createBlock(_component_TabPanel, {
                  key: riserIndex,
                  header: riserTab.riser.name
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElScrollbar, { class: "apartment-list" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(riserTab.floors, (floorsection, floorIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            key: floorIndex,
                            class: "mb-5"
                          }, [
                            _createVNode("h1", _hoisted_4, _toDisplayString(floorsection.floor.name), 1),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(floorsection.apartments, (apartment, apartmentIndex) => {
                              return (_openBlock(), _createBlock(_component_ListItemRadio, {
                                key: apartmentIndex,
                                value: apartment,
                                label: apartment.name,
                                sublabel: `${_ctx.$t('AppResourceEP.Apartment')} ${apartmentIndex + 1}`,
                                inputId: `apartment${apartmentIndex + 1}`,
                                modelValue: _ctx.selectedApartment,
                                "onUpdate:modelValue": [
                                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedApartment = $event)),
                                  _ctx.apartmentSelected
                                ],
                                name: "apartment",
                                disabled: _ctx.maxBadgesReached(apartment),
                                last: _ctx.isLast(apartmentIndex, floorsection.apartments)
                              }, _createSlots({ _: 2 }, [
                                (_ctx.maxBadgesReached(apartment))
                                  ? {
                                      name: "info-label",
                                      fn: _withCtx(() => [
                                        _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('entrancePlant.maxNumberOfBadges')), 1)
                                      ])
                                    }
                                  : undefined
                              ]), 1032, ["value", "label", "sublabel", "inputId", "modelValue", "disabled", "onUpdate:modelValue", "last"]))
                            }), 128))
                          ]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["header"]))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ScrollableTabView, {
            key: 1,
            scrollable: "",
            class: "p-tabview--custom add-badge-tab mt-3 white-back"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentEntrancePlant.buildings, (building, index) => {
                return (_openBlock(), _createBlock(_component_TabPanel, {
                  key: index,
                  header: building.name
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElScrollbar, { class: "apartment-list" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(building.apartments, (apartment, apartmentIndex) => {
                          return (_openBlock(), _createBlock(_component_ListItemRadio, {
                            key: apartmentIndex,
                            value: apartment,
                            label: apartment.name,
                            inputId: `apartment${apartmentIndex + 1}`,
                            modelValue: _ctx.selectedApartment,
                            "onUpdate:modelValue": [
                              _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedApartment = $event)),
                              _ctx.apartmentSelected
                            ],
                            name: "apartment",
                            disabled: _ctx.maxBadgesReached(apartment),
                            last: _ctx.isLast(apartmentIndex, building.apartments)
                          }, _createSlots({ _: 2 }, [
                            (_ctx.maxBadgesReached(apartment))
                              ? {
                                  name: "info-label",
                                  fn: _withCtx(() => [
                                    _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('entrancePlant.maxNumberOfBadges')), 1)
                                  ])
                                }
                              : undefined
                          ]), 1032, ["value", "label", "inputId", "modelValue", "disabled", "onUpdate:modelValue", "last"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["header"]))
              }), 128))
            ]),
            _: 1
          }))
    ])
  ], 64))
}